// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2tZ1y","subheader":"ReorderModal_subheader__2RtO7","listWrap":"ReorderModal_listWrap__35f-N"};